// Mock data for M DION LIGHTING - Certified Illumidel Dealer

export const heroData = {
  headline: "Illuminate Your Vision",
  subheadline: "Certified Illumidel dealer bringing premium architectural and landscape lighting solutions to transform your spaces",
  ctaText: "Get a Quote",
  ctaSecondary: "View Our Products",
  heroImage: "https://customer-assets.emergentagent.com/job_brand-story-hub-9/artifacts/uu9pbfol_3d000430-9fa1-4348-b5f7-6bb115f2aec5_enhanced.jpg"
};

export const servicesData = [
  {
    id: 1,
    title: "Architectural Lighting",
    shortDescription: "Stunning facade and building illumination that transforms structures into nighttime landmarks",
    fullDescription: "Our architectural lighting solutions highlight the beauty of your building's design. Using premium Illumidel fixtures, we create dramatic effects that enhance curb appeal, improve safety, and make your property stand out. From accent lighting to full facade illumination, we deliver excellence.",
    icon: "Building2",
    image: "https://customer-assets.emergentagent.com/job_brand-story-hub-9/artifacts/c77qov27_21f83088-c7e2-4828-ab9f-3a6d6b2698d8.jpg",
    features: [
      "Facade Illumination",
      "Accent Lighting",
      "Wall Washing",
      "Feature Highlighting"
    ]
  },
  {
    id: 2,
    title: "Landscape Lighting",
    shortDescription: "Transform outdoor spaces with professional landscape and garden lighting",
    fullDescription: "Create enchanting outdoor environments with our landscape lighting services. We specialize in path lighting, garden accents, tree uplighting, and water feature illumination. Our designs extend your living space into the night while enhancing security and property value.",
    icon: "TreePine",
    image: "https://customer-assets.emergentagent.com/job_brand-story-hub-9/artifacts/dq69bfjq_ac2652b5-b25f-400a-80e3-021dc455e21a.jpg",
    features: [
      "Path & Walkway Lighting",
      "Garden & Tree Uplighting",
      "Water Feature Lighting",
      "Outdoor Living Spaces"
    ]
  },
  {
    id: 3,
    title: "Commercial Lighting",
    shortDescription: "Professional lighting solutions for retail, office, and commercial properties",
    fullDescription: "Enhance your business presence with our commercial lighting expertise. We design and install lighting systems for retail stores, office buildings, parking areas, and commercial facades. Energy-efficient Illumidel products ensure lower operating costs with superior illumination.",
    icon: "Store",
    image: "https://customer-assets.emergentagent.com/job_brand-story-hub-9/artifacts/j0au7d3u_architectural_lighting_led-768x538.webp",
    features: [
      "Retail Display Lighting",
      "Office Illumination",
      "Parking Lot Lighting",
      "Signage & Branding"
    ]
  },
  {
    id: 4,
    title: "LED Retrofits & Upgrades",
    shortDescription: "Upgrade to energy-efficient LED lighting and reduce your energy costs",
    fullDescription: "Modernize your existing lighting with our LED retrofit services. We replace outdated fixtures with premium Illumidel LED solutions, dramatically reducing energy consumption while improving light quality. Most clients see 50-70% energy savings.",
    icon: "Lightbulb",
    image: "https://customer-assets.emergentagent.com/job_brand-story-hub-9/artifacts/ssx3eueh_IMG_1828.JPEG",
    features: [
      "Energy Audits",
      "Fixture Replacement",
      "Smart Controls",
      "Utility Rebate Assistance"
    ]
  }
];

export const howItWorksData = [
  {
    step: 1,
    title: "Free Consultation",
    description: "We visit your property to understand your vision and assess lighting opportunities"
  },
  {
    step: 2,
    title: "Custom Design",
    description: "Our team creates a tailored lighting plan with fixture selections and layout"
  },
  {
    step: 3,
    title: "Professional Installation",
    description: "Certified technicians install your lighting system with precision and care"
  },
  {
    step: 4,
    title: "Ongoing Support",
    description: "We provide maintenance, adjustments, and support to keep your lighting perfect"
  }
];

export const whyChooseUsData = [
  {
    title: "Certified Illumidel Dealer",
    description: "Authorized dealer with access to premium Illumidel products and warranties",
    icon: "Award"
  },
  {
    title: "Expert Designers",
    description: "Skilled lighting designers who understand architecture and aesthetics",
    icon: "Users"
  },
  {
    title: "Quality Guaranteed",
    description: "Premium fixtures backed by manufacturer warranties and our workmanship guarantee",
    icon: "Shield"
  },
  {
    title: "Energy Efficient",
    description: "LED solutions that reduce energy costs while delivering superior illumination",
    icon: "Zap"
  }
];

export const statsData = [
  { value: "250+", label: "Integrators Across Canada" },
  { value: "500+", label: "Projects Completed" },
  { value: "100%", label: "Customer Satisfaction" }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Robert Mitchell",
    role: "Homeowner, Luxury Residence",
    content: "M DION LIGHTING transformed our home's exterior. The landscape lighting is stunning and the architectural accents make our house the talk of the neighborhood.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxoZWFkc2hvdHxlbnwwfHx8fDE3NzE0MjUyODR8MA&ixlib=rb-4.1.0&q=85",
    rating: 5
  },
  {
    id: 2,
    name: "Jennifer Collins",
    role: "Property Manager, Collins Real Estate",
    content: "We've used M DION for multiple commercial properties. Their Illumidel products are top quality and the energy savings have been significant.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzE0MjUyODB8MA&ixlib=rb-4.1.0&q=85",
    rating: 5
  },
  {
    id: 3,
    name: "Marcus Johnson",
    role: "Architect, MJ Design Studio",
    content: "As an architect, I recommend M DION to all my clients. They understand design intent and execute flawlessly. True lighting professionals.",
    image: "https://images.pexels.com/photos/33871730/pexels-photo-33871730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    rating: 5
  },
  {
    id: 4,
    name: "Amanda Foster",
    role: "Restaurant Owner, The Golden Fork",
    content: "The ambiance lighting they installed has completely elevated our restaurant's atmosphere. Customers constantly compliment the beautiful lighting.",
    image: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxoZWFkc2hvdHxlbnwwfHx8fDE3NzE0MjUyODR8MA&ixlib=rb-4.1.0&q=85",
    rating: 5
  },
  {
    id: 5,
    name: "Thomas Wright",
    role: "Facilities Director, Wright Industries",
    content: "The LED retrofit saved us over 60% on energy costs. M DION handled everything professionally from audit to installation. Highly recommend!",
    image: "https://images.unsplash.com/photo-1611432579699-484f7990b127?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxoZWFkc2hvdHxlbnwwfHx8fDE3NzE0MjUyODR8MA&ixlib=rb-4.1.0&q=85",
    rating: 5
  },
  {
    id: 6,
    name: "Diana Reyes",
    role: "Homeowner, Sunset Estates",
    content: "From consultation to completion, the team was professional and attentive. Our outdoor living space is now usable well into the evening. Amazing work!",
    image: "https://images.pexels.com/photos/262391/pexels-photo-262391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    rating: 5
  }
];

export const clientLogos = [
  { name: "Illumidel", logo: "IL" }
];

export const aboutData = {
  mission: "Our mission is to transform spaces through exceptional lighting design. As a certified Illumidel dealer, we bring premium quality products and expert installation to every project, creating environments that inspire and delight.",
  vision: "To be the region's most trusted lighting solutions provider, known for innovative designs, quality products, and outstanding customer service.",
  values: [
    {
      title: "Quality",
      description: "We use only premium Illumidel fixtures backed by industry-leading warranties"
    },
    {
      title: "Craftsmanship",
      description: "Every installation reflects our commitment to precision and excellence"
    },
    {
      title: "Innovation",
      description: "We stay current with the latest lighting technology and design trends"
    },
    {
      title: "Service",
      description: "We build lasting relationships through exceptional customer care"
    }
  ],
  team: {
    headline: "Meet Our Lighting Experts",
    description: "Our team of certified lighting designers and installation professionals brings years of experience in architectural and landscape lighting."
  }
};

export const contactData = {
  email: "mdionlighting@gmail.com",
  phone: "306-961-4333",
  whatsapp: "306-961-4333",
  address: "",
  socialMedia: {
    facebook: "",
    twitter: "",
    linkedin: "",
    instagram: ""
  }
};
